//
// BarChart.js
// gtl
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../../lib";
import "./AbstractBarChart";
import "../../core/styles/TextAttributes";
import "./BarChartStatisticType";
import "./BarChartBarLabelFitPolicy";
import "@sas-dvr/ltjs-commons/models/data/dataset/StatisticType";

var BarChart = createModule("gtl::BarChart", ["commons::PropertyOwner","commons::BaseModel","gtl::GTLModel","gtl::RendererModel","gtl::DataRendererModel","gtl::DataVisualization","gtl::AbstractOverlay","gtl::Overlay","gtl::AbstractBarChart"], EventDispatcher, [
    ,
    {
        statistic: 4,
        colorStatistic: 4,
        barLabel: 2,
        barLabelFormat: 7,
        barLabelAttributes: 1,
        segmentLabel: 2,
        barLabelFitPolicy: 4,
    },
    ,
    ,
    {
        getColorStatisticAsStatisticType: [4],
        getStatisticAsStatisticType: [4],
    },
    {
        _create: [4],
    },
    ,
]);
export default BarChart;
